import React,{useRef,useState} from "react";
import axios from "axios";
// nodejs library that concatenates classes
import { Link } from 'react-router-dom';
import classNames from "classnames";
import{LOGIN_OUT,BASE_URL_CHAT_WHATSAPP,EDIT_USER,UPDATE_USER,CLIENT_API} from "../../constants";
import Profile from "../../views/pages/Profile"
import smsImg from "../../assets/img/menu/sms.png";
import emailImg from "../../assets/img/menu/email.png";
import ivrImg from "../../assets/img/menu/ivr.png";
import rcsImg from "../../assets/img/menu/rcs.png";
import apiService from "../../variables/apiService";
import defaultimg from "../../assets/img/netxcell.png"

// reactstrap components

import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  InputGroup,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container,
  Modal,
  UncontrolledTooltip,
  Row,
  Col,
  ModalBody,
  Badge,
} from "reactstrap";
import { MDBInput } from "mdb-react-ui-kit";
import { useHistory } from "react-router-dom";
import noperson from "../../assets/img/noperson.svg";
import NotificationAlert from "react-notification-alert";
let initialValues={
  id:"",
  firstName:"",
  lastName:"",
  mobile:"",
  email:"",
  address:"",
  username:"",
  password:"",
  role:"", 
  tuserstatus: "",
  usertype: "",
  channel: "",
  agenttype: "",
  senderId:"",
  status:"",
  clientName:"",
  profile:noperson
}
const AdminNavbar = (props) => {
  
let imgurl ="";

  const [user,setUser] = React.useState(initialValues)
  const navigate = useHistory();
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [isProfile,setIsProfile] = React.useState(false);
  const notificationAlertRef = React.useRef(null);
  const profileRef = React.useRef(null)
  const [showPassword, setShowPassword] = useState(false);
  const [color, setColor] = React.useState("navbar-transparent");

  let userObj = localStorage.getItem("user");
    let userJsn = JSON.parse(userObj);

    
  React.useEffect(() => {
    getclientbyid();
    window.addEventListener("resize", updateColor);
    return function cleanup() {
      window.removeEventListener("resize", updateColor);
    };
  },[]);

  const getclientbyid=async()=>{
    
    userJsn?.client!=0&&await axios
    .post(CLIENT_API, { id: userJsn?.client })
    .then((res) => {
      console.log(res);
     imgurl=res?.data[0]?.image_url
      setUser({...user,clientName:res?.data[0]?.company_name})
      
    }).catch(e=>console.log(e))
  }

  //   const logout = () => {

  //     // localStorage.clear();
  //     localStorage.removeItem("user");
  //     // window.location.href = '/auth/login';
  //     navigate.push("/auth/login");

  // };

  const logout = () => {

    let userObj = localStorage.getItem("user");
    let user = JSON.parse(userObj);
   if(user){

   
    apiService
      .postData(LOGIN_OUT, {
        token: user?.token,
        sender_id:user?.sender_id,
        agenttype:user?.agenttype,
        role:user?.role,
        user_id:user?.user_id,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
          token: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        localStorage.clear();
        let options = {};
        options = {
          place: "tr",
          message: "Successfully logout",
          type: "success",
          autoDismiss: 3,
        };
        notificationAlertRef.current.notificationAlert(options);
        setTimeout(() => {
          navigate.push("/auth/login");
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
        let options = {};
        options = {
          place: "tr",
          message: "You Can't logout",
          type: "warning",
          autoDismiss: 3,
        };
        notificationAlertRef.current.notificationAlert(options);
      });
    }else{
      setTimeout(() => {
        navigate.push("/auth/login");
      }, 1000);
    }
  };
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setColor("bg-white");
    } else {
      setColor("navbar-transparent");
    }
  };
  // this function opens and closes the collapse on small devices
  const toggleCollapse = () => {
    if (collapseOpen) {
      setColor("navbar-transparent");
    } else {
      setColor("bg-white");
    }
    setCollapseOpen(!collapseOpen);
  };

 
  const openNavk = (range) => {
    const element = document.getElementById("mySidenav");

    if (range == 0) {
      element.style.right = "0";
    } else {
      element.style.right = "-80%";
    }
  };
 
const getUser =()=>{
  let userObj = localStorage.getItem("user");
  let users = JSON.parse(userObj);
  let id = users.user_id;



     apiService
      .postData(EDIT_USER, { userid: id.toString() })
      .then((response) => {
       
        const res = response.data.message[0];
        setUser({
          ...user,
          id:res?.id,
          username: res?.username,
          password: res?.password,
          mobile: res?.mobile,
          email: res?.email,
          firstName:res?.first_name,
          lastName:res?.last_name,
          profile:res?.image_url,
          tuserstatus:res?.tuserstatus,
          usertype: res?.usertype?.toString(),
          channel: res?.channel,
          agenttype: res?.agenttype,
          senderId:res?.senderid,
          status : res?.status,
          clientName: user?.clientName
        });
       

        setIsProfile(true);
      
      })
      .catch((error) => {
        console.log("????", error);
      });
  
}

  const uploadProfile=(e)=>{
    const formData = new FormData();
    formData.append("file",e.target.files[0]);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    apiService
      .postData(BASE_URL_CHAT_WHATSAPP + "/upload", formData, config)
      .then((response) => {
        setUser({...user,profile:response?.data?.Response})
        
      })
      .catch((err) => console.log("err==>", err));
  }
  const updateUser=()=>{
   console.log("local",user);
    let resultuser={
      id:user.id.toString(),
      username: user?.username,
      password: user?.password,
      mobile: user?.mobile,
      email: user?.email,
      first_name:user?.firstName,
      last_name:user?.lastName,
      image_url:user?.profile,
      role: userJsn?.role,
      client:userJsn?.client||0,
      tuserstatus: user?.tuserstatus,
      usertype: user?.usertype,
      channel: user?.channel||"",
      status:user?.status?.toString()||"",
      senderid:user?.senderId||userJsn?.senderId,
      systemid:user?.systemid||userJsn?.systemid,

      
    }

    
    apiService
    .postData(UPDATE_USER, resultuser)
    .then((response) => {
      let options = {};
      options = {
        place: "tr",
        message: "Updated Successfully",
        type: "success",

        autoDismiss: 2,
      };
      notificationAlertRef.current.notificationAlert(options);
     // setUser(initialValues);
      setIsProfile(false)
     
    })
    .catch((error) => {
      console.log("Update User--", error);
    });

  }
  const onchangeHandler = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };
  return (
    <>
    <Modal isOpen={isProfile} toggle={()=>setIsProfile(false)}>
            <div className="modal-header justify-content-center">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={()=>setIsProfile(false)}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h3 className="title title-up multicolortext">Update Profile</h3>
            </div>
            <ModalBody className="modelbody ">
              <Row >
              <Col md="5" sm="12" className="mb-2"></Col>
              <Col md="3" sm="12" className="mb-2">
              <input
                  ref={profileRef}
                    type="file"
                    id="file"
                    accept="image/png,image/jpeg"
                    onChange={(e) => {
                     uploadProfile(e);
                   
                    }}
                    style={{display:"none"}}
                  />
                  
                  <img src={user?.profile?user?.profile:noperson}  alt="no image" onClick={()=>profileRef.current.click()}  style={{borderRadius:"50px" ,height:"100px",width:"100px"}}/>
                </Col>
              </Row>
              <Row>
              <Col sm="4" className="mb-2">
                  <MDBInput
                    label="First Name"
                    type="text"
                    name="firstName"
                    value={user.firstName}
                    onChange={(e)=>onchangeHandler(e)}
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <MDBInput
                    label="Last Name"
                    type="text"
                    name="lastName"
                    value={user.lastName}
                    onChange={(e)=>onchangeHandler(e)}
                  />
                </Col>
                <Col sm="4" className="mb-2">
                  <MDBInput
                    label="Email Id"
                    type="text"
                    name="email"
                    value={user.email}
                    onChange={(e)=>onchangeHandler(e)}
                  />
                </Col>
                <Col sm="4" >
                  <MDBInput
                    label="Mobile"
                    type="text"
                    name="mobile"
                    value={user.mobile}
                    onChange={(e)=>onchangeHandler(e)}
                  />
                </Col>
                <Col sm="4" >
                  <MDBInput
                    label="User Name"
                    type="text"
                    name="username"
                    value={user.username}
                    onChange={(e)=>onchangeHandler(e)}
                  />
                </Col>

                <Col sm="4" style={{display:"flex"}}>
                  <MDBInput
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={user.password}
                    onChange={(e)=>onchangeHandler(e)}
                  />
                  
                   <i style={{border:"none"}}
                      onClick={() => setShowPassword(!showPassword)}
                      className={
                        showPassword
                          ? "fa fa-eye showPassword"
                          : "fa fa-eye-slash showPassword"
                      }
                      aria-hidden="true"
                    ></i>
                   
                </Col>
              
               

          
                <Col sm="12" className="">
                  <Button
                    type="submit"
                    className="btn btn-icon btn-primary mt-4 pull-right"
                    onClick={()=>updateUser()}
                  >
                    <i className="tim-icons icon-double-right"></i>
                  </Button>
                </Col>
              </Row>
            </ModalBody>
          </Modal>
      <Navbar
        className={classNames("navbar-absolute", {
          [color]: props.location.pathname.indexOf("full-screen-map") === -1,
        })}
        expand="lg"
      >
        <Container fluid>
          <NotificationAlert ref={notificationAlertRef} />
          <div className="navbar-wrapper">
            <div className="navbar-minimize d-inline">
              <Button
                className="minimize-sidebar btn-just-icon"
                color="link"
                id="tooltip209599"
                onClick={props.handleMiniClick}
              >
                <i className="tim-icons icon-align-center visible-on-sidebar-regular" />
                <i className="tim-icons icon-bullet-list-67 visible-on-sidebar-mini" />
              </Button>
              <UncontrolledTooltip
                delay={0}
                target="tooltip209599"
                placement="right"
              >
                Sidebar toggle
              </UncontrolledTooltip>
            </div>
            <div
              className={classNames("navbar-toggle d-inline", {
                toggled: props.sidebarOpened,
              })}
            >
              <button
                className="navbar-toggler"
                type="button"
                onClick={props.toggleSidebar}
              >
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </button>
            </div>
           {console.log("--->449--",defaultimg)}
            <NavbarBrand href="#pablo" onClick={(e) => e.preventDefault()}>
              <span className="multicolortext">  
              {/* require("../../assets/img/webicon/sms.png") */}
              <img style={{marginRight:"10px"}} alt="converge-now brand icon" src={imgurl||defaultimg} height={40}  />
              
              {props.brandText}
              </span>
            </NavbarBrand>
          </div>
        
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navigation"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={toggleCollapse}
          >
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </button>
          <Collapse navbar isOpen={collapseOpen}>
            <Nav className="ml-auto" navbar>
              <div className="mt-2 mr-2">
                <Badge color="info">
                 
                {user?.clientName}
                </Badge>
                </div>
              {/* <div className="notification_alert">
                <div class="notification d-none d-lg-block d-xl-block"></div>
                <i
                  className="tim-icons icon-bell-55"
                  onClick={() => openNavk(0)}
                />
              </div> */}
              <div id="mySidenav" class="sidenavk">
               
                <h2 className="headding" style={{paddingLeft:"10px",color:"white",position:"absolute",top:"10px"}}>Notifications</h2>
                <a
                  href="javascript:void(0)"
                  class="closebtn"
                  onClick={() => openNavk(-80)}
                >
                  &times;
                </a>
               
                
                <div className="notification_alert_fullbox">
                  <div className="notification_alert_box">
                    <div className="box-img">
                      {/* <img
                        alt="..."
                        src={require("../../assets/img/webicon/sms.png")}
                      /> */}
                      <img src={smsImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                    <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 16/11/2023 22:11</p>
                      <h4>Kotilingam</h4>
                      <p>
                        Please Update the status eod...
                      </p>
                    </div>
                  </div>
                  <div className="notification_alert_box">
                    <div className="box-img">
                      
                       <img src={emailImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                    <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 16/11/2023 21:09</p>
                      <h4>Shiva</h4>
                      <p>
                        Please find the root cause of ticket 01342...
                      </p>
                    </div>
                  </div>
                  <div className="notification_alert_box">
                    <div className="box-img">
                      
                       <img src={ivrImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                    <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 16/11/2023 14:11</p>
                      <h4>Rajesh</h4>
                      <p>
                        Invitaion from Hr Team...
                      </p>
                    </div>
                  </div>
                  <div className="notification_alert_box">
                    <div className="box-img">
                      
                       <img src={rcsImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                    <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 14/11/2023 09:34</p>
                      <h4>Srinu</h4>
                      <p>
                        Ticket reopend No:00876...
                      </p>
                    </div>
                  </div>
                  <div className="notification_alert_box">
                    <div className="box-img">
                      
                       <img src={smsImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                    <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 14/11/2023 10:19</p>
                      <h4>Ranjan</h4>
                      <p>
                        Please submit the form by ...
                      </p>
                    </div>
                  </div>
                  <div className="notification_alert_box">
                    <div className="box-img">
                      
                       <img src={emailImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                    <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 14/11/2023 21:13</p>
                      <h4>Surya</h4>
                      <p>
                       New Ticket assigned to you pleas...
                      </p>
                    </div>
                  </div>
                  <div className="notification_alert_box">
                    <div className="box-img">
                      
                       <img src={ivrImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                    <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 14/11/2023 23:14</p>
                      <h4>Rahul</h4>
                      <p>
                       Ticket  0083 closed...
                      </p>
                    </div>
                  </div>
                  <div className="notification_alert_box">
                    <div className="box-img">
                      
                       <img src={rcsImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                    <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 12/11/2023 12:12</p>
                      <h4>Rajesh</h4>
                      <p>
                        Kotilingam sdnajksdh adk jhdsa dkjah dkahd dh jdga...
                      </p>
                    </div>
                  </div>
                  <div className="notification_alert_box">
                    <div className="box-img">
                      
                       <img src={smsImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                    <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 12/11/2023 05:34</p>
                      <h4>Jaya</h4>
                      <p>
                        Kotilingam sdnajksdh adk jhdsa dkjah dkahd dh jdga...
                      </p>
                    </div>
                  </div>
                  <div className="notification_alert_box">
                    <div className="box-img">
                      
                       <img src={ivrImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                    <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 11/11/2023 18:03</p>
                      <h4>Anoj</h4>
                      <p>
                        Kotilingam sdnajksdh adk jhdsa dkjah dkahd dh jdga...
                      </p>
                    </div>
                  </div>
                  <div className="notification_alert_box">
                    <div className="box-img">
                      
                       <img src={ivrImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                    <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 11/11/2023 13:03</p>
                      <h4>Teja s</h4>
                      <p>
                        Kotilingam sdnajksdh adk jhdsa dkjah dkahd dh jdga...
                      </p>
                    </div>
                  </div>
                  <div className="notification_alert_box">
                    <div className="box-img">
                      
                       <img src={ivrImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                    <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 11/11/2023 03:03</p>
                      <h4>Mahesh k</h4>
                      <p>
                       Please Submit Timesheet by EOD...
                      </p>
                    </div>
                  </div>
                  <div className="notification_alert_box">
                    <div className="box-img">
                    
                       <img src={ivrImg} width="84px" height="84px"></img>
                    </div>
                    <div className="box-content">
                      <p style={{"margin-bottom" : "2px", "color": "#837b7b!important"}}><span>Date & Time</span> : 11/11/2023 09:03</p>
                      <h4>Dhanu j</h4>
                      <p>
                        The Ticket 00823 has been clos...
                      </p>
                    </div>
                  </div>
                </div>
                
              </div>

              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  data-toggle="dropdown"
                  nav
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="photo">
                    <img alt="..." src={userJsn?.image_url?userJsn?.image_url  :(user?.profile||noperson)} />
                  </div>
                  <b className="caret d-none d-lg-block d-xl-block" />
                  <p className="d-lg-none">Log out</p>
                </DropdownToggle>
                <DropdownMenu className="dropdown-navbar" right tag="ul">
                  <NavLink tag="li" onClick={()=>getUser()}>
                    <DropdownItem className="nav-item">
                      <i class="tim-icons icon-single-02 mr-2"></i> Profile
                    </DropdownItem>
                  </NavLink>
                  <NavLink tag="li"  >
                    <DropdownItem className="nav-item">
                      {/* <Link to={{pathname : "https://converge-now.com/apis/index.html"}} target="_blank">
                      <i class="tim-icons icon-single-02 mr-2"></i> APIs
                      </Link> */}
                    <a href="https://converge-now.com/apis/index.html" target="_blank">  <i class="tim-icons icon-single-02 mr-2"></i> APIs</a>
                    </DropdownItem>
                  </NavLink>

                  <DropdownItem divider tag="li" />
                  <NavLink tag="li">
                    <DropdownItem className="nav-item" onClick={logout}>
                      <i class="tim-icons icon-upload mr-2"></i> Log out
                    </DropdownItem>
                  </NavLink>
                </DropdownMenu>
              </UncontrolledDropdown>
              <li className="separator d-lg-none" />
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
};



export default AdminNavbar;
